import { createSlice } from "@reduxjs/toolkit";

const stepperSlice=createSlice({
    name:'stepper',
    initialState:{
        activeTab:0,
        configId:'',
        stepperDetails:{},
        isPayoutCompleted:false
    },
    reducers:{
        setActiveTab:(state,action)=>{
            state.activeTab=action.payload;
        },
        setConfigId:(state,action)=>{
            state.configId=action.payload;
        },
        setStepperDetails:(state,action)=>{
            state.stepperDetails=action.payload;
        },
        setIsPayoutCompleted:(state,action)=>{
            state.isPayoutCompleted=action.payload;
        }
    }
})
export const stepperAction=stepperSlice.actions
export default stepperSlice.reducer;